export enum RolePermissionAction {
  createADemo = 'createADemo',
  duplicateDemo = 'duplicateDemo',
  deleteDemoById = 'deleteDemoById',
  restoreADemo = 'restoreADemo',
  revertDemo = 'revertDemo',
  updateDemoById = 'updateDemoById',
  createDemoDraft = 'createDemoDraft',
  updateRecordingById = 'updateRecordingById',
  createRecording = 'createRecording',
  getRoles = 'getRoles',
  createInvite = 'createInvite',
  updateOrganization = 'updateOrganization',
  updateRoleById = 'updateRoleById',
  deleteWorkspaceById = 'deleteWorkspaceById',
  restoreAWorkspace = 'restoreAWorkspace',
  getAllWorkspacesOfOrganization = 'getAllWorkspacesOfOrganization',
  getNotesForEntity = 'getNotesForEntity',
  updateNoteById = 'updateNoteById',
  createNoteForEntity = 'createNoteForEntity',
  createWorkspace = 'createWorkspace',
  updateWorkspaceById = 'updateWorkspaceById',
  removeMemberFromWorkspace = 'removeMemberFromWorkspace',
  duplicateRecord = 'duplicateRecord',
  copyRecord = 'copyRecord',
  copyDemo = 'copyDemo',
  moveDemo = 'moveDemo',
  copyTourToWorkspace = 'copyTourToWorkspace',
  moveTourToWorkspace = 'moveTourToWorkspace',
  createTour = 'createTour',
  updateTourById = 'updateTourById',
  deleteTourById = 'deleteTourById',
  restoreATour = 'restoreATour',
  duplicateTour = 'duplicateTour',
  revertTour = 'revertTour',
  createPresentation = 'createPresentation',
  createPresentationToken = 'createPresentationToken',
  deletePresentationById = 'deletePresentationById',
  getArchivedPresentations = 'getArchivedPresentations',
  getPresentationAnalytics = 'getPresentationAnalytics',
  getPresentationById = 'getPresentationById',
  getPresentationDataByToken = 'getPresentationDataByToken',
  getPresentations = 'getPresentations',
  getPresentationsByDemo = 'getPresentationsByDemo',
  restorePresentation = 'restorePresentation',
  updatePresentationById = 'updatePresentationById',
  deleteRecordingById = 'deleteRecordingById',
  getArchivedRecordings = 'getArchivedRecordings',
  getRecordingById = 'getRecordingById',
  getRecordings = 'getRecordings',
  restoreRecording = 'restoreRecording',
  revertRecord = 'revertRecord',
  spliceRecord = 'spliceRecord',
  createARecordingDraft = 'createARecordingDraft',
  moveRecord = 'moveRecord',
  createFolder = 'createFolder',
  deleteFolderById = 'deleteFolderById',
  getFolderById = 'getFolderById',
  restoreAFolder = 'restoreAFolder',
  searchFolders = 'searchFolders',
  updateFolderById = 'updateFolderById',
  createPlaybook = 'createPlaybook',
  deletePlaybookById = 'deletePlaybookById',
  duplicatePlaybook = 'duplicatePlaybook',
  getPlaybookById = 'getPlaybookById',
  movePlaybook = 'movePlaybook',
  restorePlaybook = 'restorePlaybook',
  updatePlaybookById = 'updatePlaybookById',
  createTag = 'createTag',
  getAllTags = 'getAllTags',
  tagFolder = 'tagFolder',
  tagWorkspace = 'tagWorkspace',
  getCSVWithAllWorkspacesAndTheirTagsInTheOrganization = 'getCSVWithAllWorkspacesAndTheirTagsInTheOrganization',
  updateTag = 'updateTag',
  deleteTag = 'deleteTag',
}

export enum PlanPermissionAction {
  shareDemo = 'shareDemo',
  updateShareApproval = 'updateShareApproval',
  filterClone = 'filterClone',
  createShareLink = 'createShareLink',
  getAllActiveShares = 'getAllActiveShares',
  getAllSharesOfEntity = 'getAllSharesOfEntity',
  getFilterOptionsForSharesBySource = 'getFilterOptionsForSharesBySource',
  getShareDataBySessionToken = 'getShareDataBySessionToken',
  getShareMetadataByToken = 'getShareMetadataByToken',
  getSharedEntityDataByToken = 'getSharedEntityDataByToken',
  searchAllSharesBySource = 'searchAllSharesBySource',
  sendVerificationEmailForShareInvitedUser = 'sendVerificationEmailForShareInvitedUser',
  toggleShareActiveState = 'toggleShareActiveState',
  updateShareLink = 'updateShareLink',
}

export const PermissionAction = {
  ...RolePermissionAction,
  ...PlanPermissionAction,
};

export enum PermissionKey {
  demo = 'demo',
  record = 'record',
  draft = 'draft',
  roles = 'roles',
  invites = 'invites',
  organization = 'organization',
  workspace = 'workspace',
  workspaceMember = 'workspaceMember',
  tour = 'tour',
  presentation = 'presentation',
  folder = 'folder',
  tag = 'tag',
  playbook = 'playbook',
  note = 'note',
}
